export const BASE_DOCUMENT_TITLE = 'Worknex';

interface TaskTitleOptions {
  projectKey?: string | null;
  displayNumber?: string | number | null;
  fallbackId?: string | null;
  taskId?: string | null;
  title?: string | null;
}

const hasDisplayNumber = (value?: string | number | null) =>
  value !== undefined && value !== null && `${value}`.trim().length > 0;

export const formatTaskIdentifier = ({
  projectKey,
  displayNumber,
  fallbackId,
  taskId,
}: Omit<TaskTitleOptions, 'title'>): string => {
  const trimmedKey = (projectKey || '').trim();
  if (hasDisplayNumber(displayNumber)) {
    if (trimmedKey) {
      return `${trimmedKey}-${displayNumber}`;
    }
    return `${displayNumber}`;
  }

  if (fallbackId && fallbackId.trim()) {
    return fallbackId.trim();
  }

  if (taskId) {
    return `Task ${taskId.substring(0, 6)}`;
  }

  return 'Task';
};

export const buildTaskShareTitle = (options: TaskTitleOptions) => {
  const identifier = formatTaskIdentifier(options);
  const segments = [identifier, options.title?.trim()].filter(Boolean);
  const label = segments.join(' · ');
  return `${label || identifier} | ${BASE_DOCUMENT_TITLE}`;
};





